import {Component, Input, OnInit} from '@angular/core';
import {Offer} from '../../../../../core/models/offer/offer.model';
import {NextOffersSectionStateService} from '../../../../../core/services/impl/section-services/next-offers/next-offers-section-state.service';

@Component({
  selector: 'app-offers-list',
  templateUrl: './offers-list.component.html',
  styleUrls: []
})
export class OffersListComponent implements OnInit {

  @Input() offers: Offer[];

  constructor(public offersSectionStateService: NextOffersSectionStateService) { }

  ngOnInit() {
  }

}
